import React, { Component } from 'react'
import Runner from '@protonapp/proton-runner'
import qs from 'qs'
import axios from 'axios'
import DocumentTitle from 'react-document-title'
import Favicon from 'react-favicon'
import Helmet from 'react-helmet'
import NotFound from './NotFound'

import {
  DATABASE_URL,
  ASSETS_URL,
  FILE_UPLOADS_URL,
  IMAGE_UPLOADS_URL,
  NOTIFICATIONS_URL,
} from '../config'

import { getAppIdURL, getAppURL } from '../utils/io'
import { getLibraries } from '../utils/libraries'
import LibraryLoader from './LibraryLoader'
import CloneAppFooter from './CloneAppFooter'

import './Renderer.css'

export default class Renderer extends Component {
  state = {
    app: null,
    authenticationError: false,
    librariesReady: false,
  }

  requestApp = async () => {
    let { match } = this.props
    let { appId: path } = match.params
    let host = window.location.host
    let query = `host=${encodeURIComponent(host)}&path=${path || ''}`
    const appIdURL = getAppIdURL(query)

    try {
      const { data } = await axios.get(appIdURL)
      const appURL = getAppURL(data.id)
      const authToken = process.env.REACT_APP_BACKEND_SERVICE
      axios.defaults.headers['x-server-auth'] = authToken
      const response = await axios.get(appURL)
      this.setState({ app: response.data })
    } catch (error) {
      console.error('ERROR GETTING APP ID', error)
      this.setState({ error: true })
    }
  }

  receiveApp = app => {
    this.setState({
      app,
    })
  }

  handleLoadLibraries = () => {
    this.setState({ librariesReady: true })
  }

  handleUnauthorized = () => {
    this.setState({ authenticationError: true })
  }

  getParams = () => {
    return qs.parse(window.location.search.substring(1))
  }

  componentWillMount() {
    this.requestApp()
  }

  render() {
    let { app, librariesReady, authenticationError, error } = this.state

    if (error) {
      return <NotFound />
    }

    if (authenticationError) {
      return (
        <div>
          <h1>Unauthorized</h1>
        </div>
      )
    }

    let libraries = getLibraries(app)

    return (
      <React.Fragment>
        {app && (
          <React.Fragment>
            <DocumentTitle title={app.name} />
            <Favicon url={`${getAppURL(app.id)}/icon?size=32&radius=7`} />
            <Helmet>
              <link
                rel="shortcut icon"
                href={`${getAppURL(app?.id)}/icon?size=180&radius=7`}
              />
              <link
                rel="apple-touch-icon"
                sizes="180x180"
                href={`${getAppURL(app?.id)}/icon?size=180&radius=7`}
              />
            </Helmet>
          </React.Fragment>
        )}
        <LibraryLoader app={app} onLoad={this.handleLoadLibraries} />
        <Runner
          app={librariesReady ? app : null}
          baseURL={DATABASE_URL}
          assetsBaseURL={ASSETS_URL}
          fileUploadsBaseURL={FILE_UPLOADS_URL}
          imageUploadsBaseURL={IMAGE_UPLOADS_URL}
          notificationsURL={NOTIFICATIONS_URL}
          libraries={libraries}
          marginBottom={app && app.visibility ? 74 : 0}
        />
        <CloneAppFooter app={app} />
      </React.Fragment>
    )
  }
}
